import { Routes, Route, Navigate } from 'react-router-dom';
import { IEPlug, FilterPage } from '../pages';

export default function AppRouter(): JSX.Element {
  const isIE =
    navigator.userAgent.search(/MSIE/) > 0 ||
    navigator.userAgent.search(/NET CLR /) > 0 ||
    navigator.userAgent.search(/Edge/) > 0;

  return (
    <Routes>
      <Route
        path='/'
        element={isIE ? <IEPlug /> : <FilterPage />}
      />
      <Route
        path='*'
        element={
          <Navigate
            to={'/'}
            replace
          />
        }
      />
    </Routes>
  );
}
